export { default } from "./ArticlePresentAction";
